import request from '../utils/fetch'
export function getList (data) {
  return request({
    url: '/admin/city/getList',
    method: 'get',
    requestBody: 'null',
    loading: true,
    params: data
  })
}